/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import styles from './style/index.css'
import {Dimmer} from '@targetprocess/dimmer'

export const Loader = () => (
  <div className={styles['list-spinner-container']}>
    <div key="dimmer" className={styles['list-spinner']}>
      <Dimmer key="logs-loader" type={'spinner'} loading />
    </div>
  </div>
)
